import { Box, Button, Card, CardContent, FormControl, Grid } from '@mui/material'
import { FileManagerInput } from 'common'
import React from 'react'
import { ArrowLeftCircle, UploadCloud, X, XCircle } from 'react-feather'
import { AllowedAccess } from 'react-permission-role'
import { VehicleImagesTable } from './VehicleImagesTable'
import { HeaderForm } from '../VehicleForm/HeaderForm'

const acceptConfiguration = {
  'image/jpeg': ['.jpeg', '.jpg'],
  'image/png': ['.png'],
}


export const VehicleImages = ({ useFetchInit }) => {

  const {
    globalStates,
    Actions,
    defaultData,
    Forms
  } = useFetchInit

  const {handleClickCloseForm, onSubmitVehicleImages, handleClickCleanUpFiles} = Actions

  const { FormVehicle } = Forms
  const { onDropZoneAcceptedFilesChange, onDropZoneRejectionsFilesChange, formState  } = FormVehicle
  

  return (
    <AllowedAccess permissions={['49_ADMIN', '146_CATALOGO_VEHICULOS']} renderAuthFailed={<p>Error</p>}>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
        <Grid item xs={12}>
          <Card style={{ zIndex: '1' }}>
            <CardContent>
              <div className="h4 mt-1 mb-1">Imagenes de Vehiculos</div>
              <div className="border-bottom border-dark"></div>
              <HeaderForm useFetchInit={useFetchInit}/>
              <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2, mt: 5 }}>
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 2 }}>
              
                  <form onSubmit={onSubmitVehicleImages}>
                    <FormControl fullWidth>
                      <label htmlFor="attachmentt"> * Imagenes </label>
                      <FileManagerInput
                          // datos (listados, individuales)
                          acceptedFiles={formState.acceptedFiles}
                          fileRejections={formState.fileRejections}
                          NameId='attachmentt'
                          typeFiles='IMAGES' 
                          maxFiles={5}
                          accept={acceptConfiguration}

                          // HandleClicks

                          // Funciones
                          setAcceptedFiles={onDropZoneAcceptedFilesChange}
                          setFileRejections={onDropZoneRejectionsFilesChange}
                      />
                    </FormControl>

                    <div className="text-center">
                        <Button
                            startIcon= {<UploadCloud/>}
                            variant="contained"
                            type="submit"
                            className='btn-round'
                            color='primary'
                            sx={{ marginRight: 3, marginLeft: 1 }}
                        >
                            Subir
                        </Button>
                        <Button
                            startIcon={<XCircle/>}
                            variant="contained"
                            type="button"
                            className='btn-round'
                            color='error'
                            onClick={handleClickCleanUpFiles}
                            sx={{ marginRight: 3, marginLeft: 1 }}
                        >
                            Limpiar
                        </Button>
                    </div>
                  </form>
                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={8} sx={{ mb: 2 }}>
                  <VehicleImagesTable useFetchInit = {useFetchInit}/>
                </Grid>
              </Grid>
            
              <Box className="text-center" sx={{mt: 7, mb: 7, }}>
                    <Button 
                        startIcon={<ArrowLeftCircle/>}
                        variant="contained"
                        type="button" 
                        className='btn-round'
                        color='warning'
                        onClick={handleClickCloseForm} 
                        sx={{ marginRight: 5, marginLeft: 1 }}
                    >
                        Volver
                    </Button>

                  </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </AllowedAccess>
  )
}
